import React from "react";
import { CertificateResponse } from "../../../interfaces/new-api-interfaces/certificate";
import { getImageFromServer } from "../../../assets/JS/helpers";
import { Avatar, Card, Stack, Typography } from "@mui/material";
import { defaultTranslation } from "../../../untilites/functions";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

interface CertificateCardProps {
  certificate: CertificateResponse;
}

const CourseCertificateCard: React.FC<CertificateCardProps> = ({
  certificate,
}) => {
  const { t } = useTranslation();
  return (
    <Card sx={{ padding: "30px" }}>
      <Stack flexDirection="row" gap="20px">
        <Avatar
          src={getImageFromServer(certificate.logo)}
          alt="Certificate Logo"
          sx={{ width: 60, height: 60 }}
        />
        <Stack flexDirection="column" gap={2}>
          <Typography variant="h5" sx={{ textTransform: "uppercase" }}>
            {defaultTranslation(certificate, "donor")}
          </Typography>
          <Typography>
            {defaultTranslation(certificate, "description")}
          </Typography>
          {certificate.price > 0 ? (
            <Stack flexDirection="row" gap={3}>
              <Typography sx={{ fontWeight: 600, whiteSpace: "nowrap" }}>
                {i18next.language == "en" ? "certificate fees" : "رسوم الشهادة"}
              </Typography>
              <Typography sx={{ fontWeight: 600, whiteSpace: "nowrap" }}>{`${
                certificate.price
              } ${t("syp")}`}</Typography>
            </Stack>
          ) : (
            <Typography sx={{ fontWeight: 600 }}>
              {i18next.language == "en"
                ? "without additional fees"
                : "بدون رسوم إضافية"}
            </Typography>
          )}
        </Stack>
      </Stack>
    </Card>
  );
};

export default CourseCertificateCard;
